import React from 'react';

const Genetics = () => {
  return (
    <section className="section genetics-section">
      <div className="container">
        <h2 className="section-title">Genetics of ADPKD</h2>
        <p className="section-subtitle">
          ADPKD occurs due to mutations in specific genes that affect kidney development and function.
        </p>
        <div className="grid-container-2">
          <div className="genetics-card"> 
            <h3>75-85%</h3>
            <p>PKD 1 </p><p>(Chromosome 16)</p>
          </div>
          <div className="genetics-card">
            <h3>15-25%</h3>
            <p>PKD 2 </p><p>(Chromosome 4)</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Genetics;